import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router} from '@angular/router';
import {AuthService} from './auth/auth.service';
import {NgxPermissionsService} from 'ngx-permissions';
import {ScreenSizeService} from './services/screen-size.service';

@Injectable()
export class AuthGuardService implements CanActivate {

    private screenSizeService: ScreenSizeService;

    constructor(
        public auth: AuthService,
        public router: Router
    ) {
        this.screenSizeService = ScreenSizeService.getInstance();
    }

    canActivate(route: ActivatedRouteSnapshot): boolean {
        if (!this.auth.isAuthenticated) {
            this.router.navigate(['signup']);
            return false;
        } else {
            if (route.url.length > 0 && route.url[0].path === ScreenSizeService.MOBILE_ROUTE_PATH) {
                return this.screenSizeService.isMobileScreen;
            }
        }

        return true;
    }
}



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/auth-guard.service.ts